import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M10 1a9 9 0 110 18 9 9 0 010-18zm0 1a8 8 0 100 16 8 8 0 000-16zm0 10.5a1 1 0 110 2 1 1 0 010-2zm.5-1h-1l-.5-6h2l-.5 6z" fill="#B00020" /></svg>;